export default __webpack_public_path__ + "static/media/mode-24.287cd9df.svg";